import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ShieldCheck, Globe, Tag, Calendar } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function BoxStatusKlarifikasi() {
  return <section id="box-status-klarifikasi" className="bg-background py-12 md:py-20 lg:py-24 px-4 flex justify-center items-center">
      <Card className="w-full max-w-[22rem] sm:max-w-md border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <ShieldCheck className="h-8 w-8 text-primary" strokeWidth={2.5} />
          </div>
          <CardDescription className="text-[10px] font-bold tracking-widest uppercase text-muted-foreground mb-1">
            Status Informasi
          </CardDescription>
          <CardTitle className="text-3xl md:text-4xl font-black tracking-tighter text-primary uppercase">
            Terverifikasi
          </CardTitle>
        </CardHeader>
        
        <CardContent className="pt-6">
          <div className="space-y-4">
            <div className="flex items-start gap-4 rounded-lg bg-muted/30 p-4">
              <Globe className="h-5 w-5 text-secondary mt-0.5 shrink-0" />
              <div className="flex flex-col gap-0.5">
                <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Sumber</p>
                <p className="text-sm font-semibold text-foreground leading-tight">Kementerian Komunikasi dan Digital</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4 rounded-lg bg-muted/30 p-4">
              <Tag className="h-5 w-5 text-secondary mt-0.5 shrink-0" />
              <div className="flex flex-col gap-0.5">
                <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Tipe Klarifikasi</p>
                <p className="text-sm font-semibold text-foreground leading-tight">Fakta Valid</p>
              </div>
            </div>

            <div className="flex items-start gap-4 rounded-lg bg-muted/30 p-4">
              <SafeHydrate><Calendar className="h-5 w-5 text-secondary mt-0.5 shrink-0" /></SafeHydrate>
              <div className="flex flex-col gap-0.5">
                <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Tanggal Verifikasi</p>
                <p className="text-sm font-semibold text-foreground leading-tight">24 Oktober 2023</p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <Button className="w-full h-12 text-base font-bold" variant="outline">
              Unduh Laporan PDF
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>;
}